import { call, put, takeEvery } from 'redux-saga/effects';
import { handleApiResponse } from '../../utils/functions';
import {
    CREATE_OCCUPANCY, DELETE_OCCUPANCY, GET_ALL_OCCUPANCY_LIST, GET_OCCUPANCY_BY_ID, UPDATE_OCCUPANCY,
    GET_OCCUPANCY_MODE_OPTIONS
} from '../storeTypes';

const File = 'CouponSaga';

import {
    GetAllOccupancyApi,
    CreateOccupancyApi,
    UpdateOccupancyApi,
    GetOccupancyByIdApi,
    DeleteOccupancyApi
} from '../../utils/api';
import { ActionCreateOccupancySuccess, ActionGetAllOccupancyListSuccess, ActionGetOccupancyByIDSuccess, ActionUpdateOccupancySuccess, ActionGetOccupancyModeOptionsSuccess } from '../Actions/occupancyAction';

function* GetAllOccupancySaga(action) {
    try {
        const response = yield call(GetAllOccupancyApi, action.payload);
        if (response?.status === 200) {
            yield put(ActionGetAllOccupancyListSuccess(response?.data?.data || []));
        }
    } catch (error) {
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callback);
    }
}

function* CreateOccupancySaga(action) {
    try {
        const response = yield call(CreateOccupancyApi, action.payload);
        if (response) {
            action?.callBack(response?.data);
            yield put(ActionCreateOccupancySuccess(response?.data));
        }
    } catch (error) {
        if (error?.response?.status === 400) {
            action?.callBack(error?.response?.data);
        }
    }
}

function* UpdateOccupancySaga(action) {
    try {
        const response = yield call(UpdateOccupancyApi, action.payload);
        if (response?.status === 200) {
            action?.callBack(response?.data);
            yield put(ActionUpdateOccupancySuccess(response?.data));
        }
    } catch (error) {
        if (error?.response?.status === 400) {
            action?.callBack(error?.response?.data);
        }
    }
}

function* GetOccupancyByIDSaga(action) {
    try {
        const response = yield call(GetOccupancyByIdApi, action.payload);
        if (response?.status === 200) {
            yield put(ActionGetOccupancyByIDSuccess(response?.data?.data || {}));
        }
    } catch (error) {
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
    }
}

function* DeleteOccupancySaga(action) {
    try {
        const response = yield call(DeleteOccupancyApi, action.payload);
        if (response?.status === 200) {
            action?.callBack(200);
        }
    } catch (error) {
        console.log(File + '/DeleteCouponSaga Error:', error);
    }
}

function* GetOccupancyOptionsSaga(action) {
    try {
        const response = yield call(GetAllOccupancyApi, action.payload);
        if (response?.status === 200) {
            yield put(ActionGetOccupancyModeOptionsSuccess(response?.data?.data || []));
        }
    } catch (error) {
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callback);
    }
}

export function* occupancySaga() {
    yield takeEvery(GET_ALL_OCCUPANCY_LIST, GetAllOccupancySaga);
    yield takeEvery(CREATE_OCCUPANCY, CreateOccupancySaga);
    yield takeEvery(UPDATE_OCCUPANCY, UpdateOccupancySaga);
    yield takeEvery(GET_OCCUPANCY_BY_ID, GetOccupancyByIDSaga);
    yield takeEvery(DELETE_OCCUPANCY, DeleteOccupancySaga);
    yield takeEvery(GET_OCCUPANCY_MODE_OPTIONS, GetOccupancyOptionsSaga);
}